<template>
  <div :class="contentClass">
    <h4><slot name="titulo"></slot></h4>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemFerramentaEstudo',
  props: {
    contentClass: {
      type: String,
      default: 'box-branco'
    }
  }
}
</script>

<style scoped>

</style>
